<template>
  <div class="content-wrapper questionnare-wrapper questionnare-question-5">
    <div class="d-flex align-items-start justify-content-center full-height">
      <div class="center full-width">
        <div class="small-text uppercase">Question 3 of 4</div>
        <h3 class="my-4 general-title">
          What &amp; how will you order your Passoni?
        </h3>
        <div class="question-container my-9 d-flex">
          <button
            class="btn btn-outline-primary questionnaire-prev"
            type="button"
            value="Previous question"
            v-on:click="$emit('go-back')"
          >
            Previous question
          </button>
          <select class="center" name="likely" v-model="inputLikely">
            <option selected disabled>LEVEL OF INTEREST</option>
            <option value="just browsing">JUST BROWSING</option>
            <option value="reasonably interested">REASONABLY INTERESTED</option>
            <option value="very interested">VERY INTERESTED</option>
            <option value="i will order">I WILL ORDER</option>
          </select>
          <select class="center" name="when" v-model="inputWhen">
            <option selected disabled>TIMING</option>
            <option value="12month">NEXT 12 MONTHS</option>
            <option value="3month">NEXT 3 MONTH</option>
            <option value="immediately">IMMEDIATELY</option>
          </select>
          <select class="center" name="visit" v-model="inputVisit">
            <option selected disabled>WOULD YOU VISIT US?</option>
            <option value="racer">YES. CONTACT ME TO BOOK</option>
            <option value="pleasure">
              NO. PREFER TO VISIT ONE OF YOURS DEALERS
            </option>
            <option value="long-distance">DON'T KNOW YET</option>
          </select>
          <button
            class="btn btn-outline-primary questionnaire-next"
            type="button"
            value="Next question"
            v-on:click="localGoNext"
          >
            Next question
          </button>
        </div>
      </div>
      <a
        v-on:click="$emit('skip-questionnaire')"
        class="skip-button small-text uppercase"
        href="#"
        >skip questionnaire</a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "questionnare-question-3",
  data() {
    return {
      inputs: ["likely", "when", "visit"],
    };
  },
  props: ["questionAnswers"],
  methods: {
    localGoNext: function () {
      if (this.canGoNext()) {
        this.$emit("go-next");
      }
    },
    canGoNext: function () {
      let err = false;
      let firstFocus = false;
      let requiredField = ["likely", "when", "visit"];

      for (let i = 0; i < requiredField.length; i++) {
        let fieldName = requiredField[i];
        let k = this.questionAnswers[fieldName];
        if (typeof k == "undefined" || k == "") {
          if (
            !firstFocus &&
            document.querySelector("[name=" + fieldName + "]") != null
          ) {
            document.querySelector("[name=" + fieldName + "]").focus();
          }
          err = true;
          firstFocus = true;
        }
      }
      return !err;
    },
  },
  mounted() {
    document.querySelectorAll("select option:first-child").forEach((item) => {
      item.removeAttribute("selected");
      item.setAttribute("selected", "selected");
    });
  },
  computed: {
    inputLikely: {
      get() {
        return this.questionAnswers.likely;
      },
      set(answer) {
        this.$emit("set-answer", answer, "likely");
      },
    },
    inputWhen: {
      get() {
        return this.questionAnswers.when;
      },
      set(answer) {
        this.$emit("set-answer", answer, "when");
      },
    },
    inputVisit: {
      get() {
        return this.questionAnswers.visit;
      },
      set(answer) {
        this.$emit("set-answer", answer, "visit");
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.questionnare-question-5 {
  input[type="text"],
  input[type="date"],
  select {
    width: 33.3%;
  }
  .questionnaire-next,
  .questionnaire-prev {
    width: 300px !important;
    padding: 0;
  }
}
</style>
